import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../../images/loading.gif";
import LoginImg from '../../images/login1.png'
import { useNavigate } from "react-router-dom";
import { backendApi, emailValidation } from "../../api/apiService";
import { FiX } from "react-icons/fi";
const CandidateSignup = () => {
  const [userName, setUsername] = useState("");
  const navigate = useNavigate();
  const [isloading, setIsloading] = useState(false);

  const Cancel = () => {
    // navigate("/");
    navigate('/', { state: {
      candidatePopup: true
    } });
  };

  const Signup = (e) => {
    e.preventDefault();
    if (userName === "") {
      toast.warn("Please enter your Email ID", { containerId: "D" });
      return false;
    } else if (!userName.match(emailValidation)) {
      toast.warn("Kindly enter a valid email-Id", { containerId: "D" });
      return false;
    }
    setIsloading(true);
    var req = {
      functionName: "candidateCheck",
      email_id: userName,
    };
    backendApi(req)
      .then((response) => {
        console.log("responseSignup", response);
        if (response.success === "1") {
          if (response.userExists === 1) {
            toast.error("Something went wrong.Please try again later", {
              containerId: "D",
            });
          } else {
            navigate("/register", {
              state: {
                email: userName,
              },
            });
          }
        }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setIsloading(false);
      });
  };
  return (
       <div className="login_popup login-wrapper">
       <ToastContainer
        enableMultiContainer
        containerId={"D"}
        position="bottom-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    <div className="login_inner_popup">
    <FiX className="popup_close_div" 
    // onClick={()=>props.HideLoginPopup()}
    onClick={Cancel}
    />
        <div className="left_login_inner_popup">
            <div className="login_inner_svg">
                <img src={LoginImg} className="img-fluid" width="100%" height="100%"/>
            </div>
            
        </div>
        <div className="right_login_inner_popup">
            <div className="login_head">Signup</div>
            <div className="inner_login_container">
           <div className="login_form">
           <input type="text" className="login_input" placeholder="Email-Id"
            value={userName}
            onChange={(e) => setUsername(e.target.value)}
           />

            <div className="d-flex align-items-center justify-content-between">
            <a className="btn-cancel mt-1" onClick={Cancel}>
                Back to Login
              </a>
              <a
                onClick={Signup}
                className="login_btn"
              >
                {isloading ? (
                  <img src={Loading} alt="loaderImg" width={20} height={20} />
                ) : (
                  "Signup"
                )}
              </a>
                </div>
           </div>
            </div>           
        </div>
    </div>
   </div>

  );
};

export default CandidateSignup;
